"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _brands = require("../../utils/brands/brands");
var _SaleTagFilled = require("../icons/SaleTagFilled");
var _sizeModule = _interopRequireDefault(require("./size.module.scss"));
var _sizeContext = require("./sizeContext");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["value", "children", "unavailable", "type", "selected", "disabled", "id", "className", "minimiseLabelPadding", "hasReducedPrice", "reducedPriceText", "Tag", "buttonProps"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var propTypes = {
  /** Sizes to be displayed within the list */
  children: _propTypes.default.string.isRequired,
  /** The value of the size, defaults to the children */
  value: _propTypes.default.string,
  /** The type of the underlying input element */
  type: _propTypes.default.oneOf(['radio', 'checkbox']),
  /** The name of the size input, should be set via SizeList component */
  /** Whether the size is unavailable */
  unavailable: _propTypes.default.bool,
  /** Whether the size is selected */
  selected: _propTypes.default.bool,
  /** Function to be called when a size is selected, should be set via SizeList component */
  /** Custom Id for form element */
  id: _propTypes.default.string,
  /** Custom className */
  className: _propTypes.default.string,
  /** Whether or not to minimise label padding to prevent e.g. double-height buttons */
  minimiseLabelPadding: _propTypes.default.bool,
  /** Displays the Reduced text below the size */
  hasReducedPrice: _propTypes.default.bool,
  /** Displays the given text as label or by default `Reduced` text will be displayed */
  reducedPriceText: _propTypes.default.string
};
var Size = function Size(_ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    children = _ref.children,
    _ref$unavailable = _ref.unavailable,
    unavailable = _ref$unavailable === void 0 ? false : _ref$unavailable,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'radio' : _ref$type,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    disabled = _ref.disabled,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$minimiseLabelPad = _ref.minimiseLabelPadding,
    minimiseLabelPadding = _ref$minimiseLabelPad === void 0 ? false : _ref$minimiseLabelPad,
    _ref$hasReducedPrice = _ref.hasReducedPrice,
    hasReducedPrice = _ref$hasReducedPrice === void 0 ? false : _ref$hasReducedPrice,
    _ref$reducedPriceText = _ref.reducedPriceText,
    reducedPriceText = _ref$reducedPriceText === void 0 ? 'Reduced' : _ref$reducedPriceText,
    _ref$Tag = _ref.Tag,
    Tag = _ref$Tag === void 0 ? 'input' : _ref$Tag,
    _ref$buttonProps = _ref.buttonProps,
    buttonProps = _ref$buttonProps === void 0 ? {} : _ref$buttonProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useSize = (0, _sizeContext.useSize)(),
    _useSize$name = _useSize.name,
    name = _useSize$name === void 0 ? 'size' : _useSize$name,
    _useSize$onClick = _useSize.onClick,
    _onClick = _useSize$onClick === void 0 ? function () {} : _useSize$onClick,
    longestLabel = _useSize.longestLabel,
    brand = _useSize.brand,
    _useSize$hasDiorPromo = _useSize.hasDiorPromosEnabled,
    hasDiorPromosEnabled = _useSize$hasDiorPromo === void 0 ? false : _useSize$hasDiorPromo;
  var isDior = (0, _brands.isDiorBrand)(brand) && hasDiorPromosEnabled;
  var labelClasses = (0, _classnames.default)(_sizeModule.default['c-size__label'], _defineProperty(_defineProperty({}, _sizeModule.default['c-size__label--unavailable'], unavailable), _sizeModule.default['c-size__label--minimisePadding'], minimiseLabelPadding));
  var ownId = "".concat(name, "_").concat((0, _react.useId)());
  var thresholdClass = (0, _classnames.default)(_defineProperty(_defineProperty({}, _sizeModule.default["c-sizeItem--three"], longestLabel === 'medium'), _sizeModule.default["c-sizeItem--six"], longestLabel === 'small'));
  var label = hasReducedPrice ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
    className: (0, _classnames.default)(_sizeModule.default['c-size__reduced'], _defineProperty({}, _sizeModule.default['c-size__reduced--dior'], isDior)),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: _sizeModule.default['c-size__text'],
      children: children
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: _sizeModule.default['c-size__reducedPriceText'],
      children: reducedPriceText
    })]
  }) : children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", _objectSpread(_objectSpread({
    className: (0, _classnames.default)(_sizeModule.default['c-sizeItem'], _defineProperty({}, thresholdClass, Boolean(longestLabel)), className)
  }, rest), {}, {
    "data-jlds": true,
    children: Tag === 'input' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      "data-jlds": true,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        checked: selected,
        className: _sizeModule.default['c-size__input'],
        "data-testid": "size:option:input",
        disabled: disabled,
        id: id || ownId,
        name: name,
        onChange: function onChange(e) {
          _onClick(e.target.value);
        },
        type: type,
        value: value || children
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
        className: labelClasses,
        htmlFor: id || ownId,
        children: [label, unavailable && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: _sizeModule.default['c-size__properties'],
          children: [' ', "currently unavailable"]
        })]
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(Tag, _objectSpread(_objectSpread({
      className: (0, _classnames.default)(labelClasses, _defineProperty(_defineProperty({}, _sizeModule.default['c-size__label--selected'], selected), _sizeModule.default['c-size__label--disabled'], disabled)),
      "data-testid": "size:option:button",
      onClick: function onClick() {
        if (!disabled) {
          _onClick(value || children);
        }
      },
      tabIndex: disabled ? -1 : undefined,
      type: Tag === 'button' ? 'button' : undefined
    }, buttonProps), {}, {
      "data-jlds": true,
      children: [label, unavailable && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: _sizeModule.default['c-size__properties'],
        children: [' ', "currently unavailable"]
      })]
    }))
  }));
};
Size.propTypes = propTypes;
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(Size);